module.exports = __webpack_public_path__ + "static/media/pic6.3e8a4593.jpg";